import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const SUPPORTED_LANGS = ['hr', 'en'];

export function getLangFromPath(pathname) {
  const seg = pathname.split('/')[1];
  if (SUPPORTED_LANGS.includes(seg)) return seg;
  return 'hr';
}

export function stripLang(pathname) {
  const parts = pathname.split('/').filter(Boolean);
  if (SUPPORTED_LANGS.includes(parts[0])) parts.shift();
  return '/' + parts.join('/');
}

export function useLangLink() {
  const location = useLocation();
  const lang = getLangFromPath(location.pathname);
  return (path) => {
    if (path.startsWith('/thank_you')) return path;
    if (path === '/' || path === '') return `/${lang}`;
    return `/${lang}${path.startsWith('/') ? path : `/${path}`}`;
  };
}

export function useSwitchLang() {
  const location = useLocation();
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  return (newLang) => {
    const rest = stripLang(location.pathname);
    const target = rest === '/' ? `/${newLang}` : `/${newLang}${rest}`;
    i18n.changeLanguage(newLang);
    // preserve hash, preserve scroll position (no scroll to top)
    navigate(target + location.search + location.hash, { state: { skipScroll: true } });
  };
}
